import { useLocale } from 'next-intl'

import Button, { ButtonVariants } from '~/components/atoms/Button/Button'
import Container from '~/components/atoms/Container/Container'
import Text, { TextSizes } from '~/components/atoms/Text/Text'
import { useMediaQuery } from '~/services/useMediaQuery'
import bp from '~/styles/breakpoints/breakpoints'

import styles from './DirectoryBanner.module.css'

interface DirectoryBannerProps {
  summary: string
  linkText: string
}

export default function DirectoryBanner({
  summary = 'A curated selection of trusted partners to build and maintain a blue chip art collection',
  linkText,
}: DirectoryBannerProps) {
  const locale = useLocale()
  const isMobile = useMediaQuery(`(max-width: ${bp.bpMedium})`)

  if (locale !== 'en') {
    return null
  }

  return (
    <div className={styles.directoryBanner}>
      <Container>
        <div className={styles.directoryBannerContent}>
          <Text className={styles.title} size={TextSizes.primaryTitleLrg}>
            <svg
              width="17"
              height="22"
              viewBox="0 0 17 22"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M8.5 12C10.1569 12 11.5 10.6569 11.5 9C11.5 7.34315 10.1569 6 8.5 6C6.84315 6 5.5 7.34315 5.5 9C5.5 10.6569 6.84315 12 8.5 12Z"
                stroke="white"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M8.5 21C12.5 17 16.5 13.4183 16.5 9C16.5 4.58172 12.9183 1 8.5 1C4.08172 1 0.5 4.58172 0.5 9C0.5 13.4183 4.5 17 8.5 21Z"
                stroke="white"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
            <em>The</em>Directory
          </Text>
          <Text className={styles.summary} size={TextSizes.secondaryTitleLrg}>
            {summary}
          </Text>
          <Button
            iconLeft
            variant={
              isMobile ? ButtonVariants.textLink : ButtonVariants.primaryLight
            }
            smallFont
            reducedPadding
            link="/directory"
          >
            {linkText || 'Find out more'}
          </Button>
        </div>
      </Container>
    </div>
  )
}
